module.exports = __webpack_public_path__ + "ttnyc-logo-old.jpg?6ceca660da900485fdb0b58dbda19e24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/ttnyc-logo-old.jpg
// module id = 601
// module chunks = 0